export const auth = {
  // Login page
  "login.title": "Login",
  "login.subtitle": "Sign in to your account",
  "login.email": "Email address",
  "login.password": "Password",
  "login.remember": "Remember me",
  "login.forgot": "Forgot password?",
  "login.submit": "Sign In",
  "login.no_account": "Don't have an account?",
  "login.register": "Create account",
  "login.welcome": "Welcome! 👋",
  "login.already_signed_in": "You are already signed in.",
  "login.home": "Back to home",
  "login.new_to_suji": "New to Suji?",
  "login.create_account_benefits": "Create an account to access thousands of verified Nigerian suppliers.",

  // Register page
  "register.title": "Create your account 🚀",
  "register.subtitle": "Join our community today",
  "register.first_name": "First name",
  "register.last_name": "Last name",
  "register.email": "Email address",
  "register.password": "Password",
  "register.confirm_password": "Confirm password",
  "register.account_type": "Account type",
  "register.customer": "Customer",
  "register.supplier": "Supplier",
  "register.terms": "I accept the terms and conditions",
  "register.submit": "Create Account",
  "register.have_account": "Already have an account?",
  "register.login": "Sign in here",
  "register.already_member": "Already a member?",
  "register.already_signed_in": "You are already signed in.",
  "register.home": "Back to home",
  "register.benefit1": "Access to thousands of suppliers",
  "register.benefit2": "Verified and secure profiles",
  "register.benefit3": "Free and no commitment",

  // Choose role page
  "choose_role.title": "Choose your role 🎯",
  "choose_role.subtitle": "Select the account type that matches your needs",
  "choose_role.buyer": "Buyer",
  "choose_role.buyer_description": "Search and contact verified Nigerian suppliers",
  "choose_role.search": "Advanced search",
  "choose_role.direct_contact": "Direct contact",
  "choose_role.certified_profiles": "Certified profiles",
  "choose_role.supplier": "Supplier",
  "choose_role.supplier_description": "Create your business profile and manage your products",
  "choose_role.business_profile": "Business profile",
  "choose_role.product_management": "Product management",
  "choose_role.dashboard": "Dashboard",
  "choose_role.admin": "Administrator",
  "choose_role.admin_description": "Manage the platform and categories",
  "choose_role.user_management": "User management",
  "choose_role.category_management": "Category management",
  "choose_role.moderation": "Moderation",
  "choose_role.processing": "Processing...",
  "choose_role.please_wait": "Please wait",
  "choose_role.home": "Back to home",
  "choose_role.need_help": "Need help choosing?",
  "choose_role.help_description": "Choose {{buyer}} to search for suppliers, or {{supplier}} to promote your business.",
  "choose_role.admin_not_authorized": "You are not authorized to become an administrator. Contact an existing administrator to get rights.",
  "choose_role.error": "Error selecting role",

  // Supplier setup page
  "supplier_setup.title": "Create your supplier profile 📦",
  "supplier_setup.subtitle": "Complete your business information to get started",
  "supplier_setup.step": "Step {{current}} of {{total}}",
  "supplier_setup.almost_done": "Almost done!",
  "supplier_setup.basic_info": "Basic information",
  "supplier_setup.business_name": "Business name",
  "supplier_setup.business_name_placeholder": "e.g.: ABC Ltd",
  "supplier_setup.category": "Category",
  "supplier_setup.select_category": "Select a category",
  "supplier_setup.description": "Description",
  "supplier_setup.description_placeholder": "Describe your business and services",
  "supplier_setup.profile_image": "Profile image",
  "supplier_setup.profile_image_placeholder": "Click to upload or drag and drop",
  "supplier_setup.image_gallery": "Image gallery",
  "supplier_setup.image_gallery_placeholder": "Click to upload or drag and drop images",
  "supplier_setup.contact_info": "Contact information",
  "supplier_setup.phone": "Phone",
  "supplier_setup.phone_placeholder": "Phone number",
  "supplier_setup.email": "Email",
  "supplier_setup.website": "Website",
  "supplier_setup.website_placeholder": "https://your-site.com",
  "supplier_setup.address_info": "Address",
  "supplier_setup.address": "Address",
  "supplier_setup.address_placeholder": "Full address",
  "supplier_setup.city": "City",
  "supplier_setup.city_placeholder": "City name",
  "supplier_setup.state": "State",
  "supplier_setup.state_placeholder": "State name",
  "supplier_setup.business_hours": "Business hours",
  "supplier_setup.days.monday": "Monday",
  "supplier_setup.days.tuesday": "Tuesday",
  "supplier_setup.days.wednesday": "Wednesday",
  "supplier_setup.days.thursday": "Thursday",
  "supplier_setup.days.friday": "Friday",
  "supplier_setup.days.saturday": "Saturday",
  "supplier_setup.days.sunday": "Sunday",
  "supplier_setup.closed": "Closed",
  "supplier_setup.cancel": "Cancel",
  "supplier_setup.create_profile": "Create profile",
  "supplier_setup.creating_profile": "Creating profile...",
  "supplier_setup.approval_needed": "Thank you for registering! Your supplier profile has been submitted and is awaiting admin approval. You will receive an email notification once approved.",
  "supplier_setup.approval_modal.title": "Request Sent!",
  "supplier_setup.approval_modal.message": "Your supplier profile has been successfully created and is being reviewed by our team. You will receive an email notification as soon as it is approved.",
  "supplier_setup.approval_modal.button": "Back to Home",
  "supplier_setup.home": "Back to home",
  "supplier_setup.errors.business_name_required": "Business name is required",
  "supplier_setup.errors.category_required": "Category is required",
  "supplier_setup.errors.country_required": "Country is required",
  "supplier_setup.errors.city_required": "City is required",
  "supplier_setup.errors.state_required": "State is required",
  "supplier_setup.errors.email_not_available": "Email not available",
  "supplier_setup.errors.profile_creation_error": "Error creating supplier profile",
  "supplier_setup.errors.profile_exists": "A supplier profile already exists for this user",
  "supplier_setup.business_type": "Business type",
  "supplier_setup.products": "Products",
  "supplier_setup.services": "Services",

  // General
  "loading": "Loading...",
  "redirecting": "Redirecting...",
  "common.error": "Error",
  "common.ok": "OK",
  "common.success": "Success",

  // Validation messages
  "validation.required": "This field is required",
  "validation.email": "Invalid email",
  "validation.password_min": "Password must be at least 6 characters",
  "validation.password_match": "Passwords do not match",
  "validation.terms": "You must accept the terms and conditions"
};

export default auth;